import {
  courseStudentFragment,
  studentPypEvaluationFragment,
} from "./StudentPortfolioFragment";
import { gradeFragment } from "modules/CommonFragments";

import { gql } from "lib/apolloClient";

export const getCourseAllStudentQuery = gql`
  query getCourseAllStudent(
    $id: ID!
    $filters: CourseFilter
    $after: String
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $userArchivedFilters: UserArchivedFilters
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        ...courseItem
      }
    }
  }
  ${courseStudentFragment.courseStudent}
`;

export const getCourseStudentPortfolioQuery = gql`
  query getCourseStudentPortfolio(
    $id: ID!
    $filters: CourseFilter
    $after: String
    $postFilters: PostFilterInput
    $courseMapFilters: UserCourseMapFilters
    $staffRelationFilters: StaffStudentRelationFilter
    $orderBy: ORDER_BY_ENUM
    $orderByDirection: ORDER_BY_DIRECTION
    $academicYearId: ID
    $filtersWithoutSearch: CourseFilter
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        ...courseItem
      }
    }
  }
  ${courseStudentFragment.courseStudentPortfolio}
`;

export const getCourseStudentListWithInviteCodesQuery = gql`
  query getCourseStudentPortfolio(
    $id: ID!
    $filters: CourseFilter
    $after: String
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        ...courseItem
      }
    }
  }
  ${courseStudentFragment.courseStudentBasicDetails}
`;

export const getStudentPypElementRatingsQuery = gql`
  query getStudentPypElementRatings(
    $studentId: ID!
    $filtersForRecentMost: ibPYPElementRatingFilterForRecentMost
    $startDate: String
    $endDate: String
  ) {
    node(id: $studentId, type: STUDENT) {
      id
      ... on Student {
        ...studentPypEvaluationItem
      }
    }
  }
  ${studentPypEvaluationFragment.studentPypElementRatings}
`;

export const getStudentSubjectsQuery = gql`
  query getStudentSubjects(
    $id: ID!
    $filters: SubjectFilter
    $allGradesFilters: AllGradesFilters
    $gradeSubjectsFilter: SubjectFilters
    $yearGroupFilters: YearGroupFilters
    $courseFilters: CourseFilter
  ) {
    node(id: $id, type: STUDENT) {
      id
      ... on Student {
        id
        firstName
        lastName
        profileImage
        subjects(filters: $filters) {
          id
          name
          isArchived
        }
        allGrades(filters: $allGradesFilters) {
          ...gradeItem
        }
        yearGroup(filters: $yearGroupFilters) {
          id
          grade {
            id
          }
        }
        courses(filters: $courseFilters) {
          id
          grades {
            id
          }
        }
      }
    }
  }
  ${gradeFragment.gradeWithSubjectBenchmarkRootNodesBasicDetails}
`;

export const resetStudentFamilyInviteCodeMutation = gql`
  mutation resetStudentFamilyInviteCodeMutation($id: ID!) {
    platform {
      updateUser(input: { id: $id, updateParentInviteCode: true }) {
        ... on Student {
          familyInviteCode
        }
      }
    }
  }
`;

export const resetStudentSignInCodeMutation = gql`
  mutation resetStudentSignInCodeMutation($id: ID!) {
    platform {
      updateUser(input: { id: $id, updateStudentSignInCode: true }) {
        ... on Student {
          signInCode
        }
      }
    }
  }
`;

export const getTeacherCoursesStudentsQuery = gql`
  query getTeacherCoursesStudents($id: ID!, $filters: CourseFilter) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        courses(filters: $filters) {
          id
          allStudents {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const getCourseEnabledModulesQuery = gql`
  query getCourseEnabledModules(
    $id: ID!
    $enabledModlueFilters: EnabledModulesFiltersInput!
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        enabledModules(filters: $enabledModlueFilters)
        __typename
      }
      __typename
    }
  }
`;

export const checkIsTeacherAssociatedWithStudentQuery = gql`
  query checkIsTeacherAssociatedWithStudentQuery(
    $input: IsTeacherAssociatedWithStudentInput!
  ) {
    platform {
      isTeacherAssociatedWithStudent(input: $input) {
        studentId
        isAssociated
      }
    }
  }
`;
